import React, { Component } from "react";
import CancellationButton from "../cancellation/CancellationButton";
import { history } from "../../../react-app";

import { connect } from "react-redux";
import { setOrderToCancel, setOrderToDetail } from "../../../actions/index";
import CancellationModal from "../cancellation/CancellationModal";

import {
	$,
	checkoutCredentials,
	redirectToLogin
} from "../../../shared/utils";
import {
	calcOrderCancelation,
	pingUser,
	logoutUser
} from "../../../shared/requests-api";
import FinanceLink from "../FinanceLink";


const CancellationButtonRender = ({ trip, onShowCancellation: handleShowCancellation}) => {
	return (
        <CancellationButton
            callback={handleShowCancellation}
						outline={0}
			trip={trip}
			data-action="my-trips-cancellation-button-details"
        />
	);
}

class DetailsCancellationRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
			cancellationModalOpen: false,
			cancellationModalScenario: null,
			fetchingOrders: true,
			calculatingCancel: false
		};
    }

	componentWillUnmount() {
		this.setState((prevState) => ({
			...prevState,
			calculatingCancel: false
		}));
	}

	async isAuthenticated() {
		const token = checkoutCredentials().au;
		
		if(!token) {
			redirectToLogin(window);
			throw new Error('Token not found');
		}

		//Checa se o usuário está logado e redireciona ou busca suas compras
		const { data: { success: isAuthenticated }} = await pingUser(token);
		
		if(!isAuthenticated)  {
			await logoutUser();
			throw new Error('User is not logged.');
		}

		return token;
    }
    
    /** Triggers do modal de cancelamento na tela **/
	openCancellationModal(scenario) {
		$("body")
			.classList
			.add("body-lock");

		const { cancellation: { orders }} = this.props;
		const getOrderById = (orderCode, trip) => trip.order.code == orderCode;

		if (scenario.purchase) {
			scenario.order = orders.filter(getOrderById.bind(this, scenario.purchase))
			if (scenario.order.length == 1) {
				scenario.order = scenario.order[0];
			}
		}

		this.setState({
			cancellationModalOpen: true,
			cancellationModalScenario: scenario
		});
	}

	closeCancellationModal() {
		$("body")
			.classList
			.remove("body-lock");
		this.setState({
			cancellationModalOpen: false,
			cancellationModalScenario: null
		});
	}

	async handleCalculateCancellation(orderCode) {
		this.setState({ calculatingCancel: true });
		window.scrollTo(0, 0);
		try {
			const orderResponse = await calcOrderCancelation(checkoutCredentials().au, orderCode);
			this.props.setOrderToCancel(orderResponse.data);
			history.push(`/cliente/minhas-viagens-light/cancelamento?ido=${orderCode}`);
		} catch (err) {
			if (err.response.status === 400) {
				this.setState({
					calculatingCancel: false
				});
				this.openCancellationModal(err.response.data);
			} else {
				this.setState({
					calculatingCancel: false
				});
			}
		}
    }
    
    
    render() {
        const { 
			cancellationModalOpen,
			cancellationModalScenario,
		} = this.state;
        const { order: { order : order } } = this.props;
        
        return (
            <div className="details-cancellation-container">
                <div>
                    <div className="finance-wrapper">
                        <FinanceLink orderCode={order.code} disableInvoiceLink={order.status === 'CANCELADO'} />
                    </div>
                    <div>
                        <div className="cancellation-button">
                            <CancellationButtonRender
                                trip={this.props.order}
								onShowCancellation={this.handleCalculateCancellation.bind(this, order.code)}
                            />
                        </div>
                    </div>
                </div>
                <div className={`cancellation-modal tingle-modal ${ cancellationModalOpen ? "tingle-modal--visible" : ""}`}>
                    <CancellationModal
                        open={cancellationModalOpen}
                        scenario={cancellationModalScenario}
                        closeModal={this.closeCancellationModal.bind(this)}
                        btnAction={this.closeCancellationModal.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
	cancellation: state.cancellation
});

const mapDispatchToProps = dispatch => ({
	setOrderToCancel: orderObj => dispatch(setOrderToCancel(orderObj)),
	setOrderToDetail: order => dispatch(setOrderToDetail(order))
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailsCancellationRow);